import { useState, useEffect, useCallback } from "react";
import { api } from "./api";

// Supplier classification (Lieferantenart) — shared labels.
export const SUPPLIER_TYPES = [
  { id: "manufacturer", label: "Hersteller" },
  { id: "contract_manufacturer", label: "Lohnfertiger / 3rd-Party-Producer" },
  { id: "distributor", label: "Händler / Distributor" },
  { id: "raw_material", label: "Rohstofflieferant" },
  { id: "service", label: "Dienstleister" },
];
export const supplierTypeLabel = (id) =>
  (SUPPLIER_TYPES.find((t) => t.id === id) || {}).label || id;

// Common certification suggestions (free additions allowed).
export const CERT_SUGGESTIONS = [
  "ISO 9001", "ISO 14001", "ISO 45001", "ISO 50001", "IATF 16949",
  "BRCGS", "FSC", "PEFC", "Sedex/SMETA", "EcoVadis", "GMP",
];

function flatten(nodes, parentPath = "", level = 0, parentId = null, acc = []) {
  for (const n of nodes || []) {
    const path = parentPath ? `${parentPath} / ${n.name}` : n.name;
    const hasChildren = !!(n.children && n.children.length);
    acc.push({ id: n.id, code: n.code, name: n.name, path, level, parentId, hasChildren, isLeaf: !hasChildren });
    flatten(n.children, path, level + 1, n.id, acc);
  }
  return acc;
}

// Hook: loads the commodity-group tree once and exposes tree + label lookups.
export function useCommodityGroups() {
  const [tree, setTree] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(() => {
    setLoading(true);
    return api.get("/config/commodity-groups")
      .then((r) => setTree(r.data.tree || []))
      .catch(() => setTree([]))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const flat = flatten(tree);
  const byId = Object.fromEntries(flat.map((f) => [f.id, f]));
  const pathsFor = (ids) => (ids || []).map((i) => byId[i] && byId[i].path).filter(Boolean);

  return { tree, flat, byId, pathsFor, loading, reload, setTree };
}
